import LegalDocumentPage from "@/components/layout/LegalDocumentPage";
import {
  CLINIC_ADDRESS_LINE_1,
  CLINIC_ADDRESS_LINE_2,
  CONTACT_EMAIL,
  PHONE_NUMBER,
} from "@/config/site";

const LAST_UPDATED = "February 22, 2026";

const sections = [
  {
    title: "1. Our Commitment",
    paragraphs: [
      "We aim to deliver high standards of care and service. If something has not met your expectations, we welcome feedback and will investigate concerns fairly, respectfully, and promptly.",
    ],
  },
  {
    title: "2. How to Make a Complaint",
    bullets: [
      `Email: ${CONTACT_EMAIL}`,
      `Phone: ${PHONE_NUMBER}`,
      `Post: ${CLINIC_ADDRESS_LINE_1}, ${CLINIC_ADDRESS_LINE_2}`,
      "In person: speak to a member of our team and ask for the Complaints Lead.",
    ],
  },
  {
    title: "3. Information to Include",
    bullets: [
      "Your full name and preferred contact details.",
      "Patient name (if different) and relationship to the patient.",
      "A clear description of what happened and when.",
      "Any supporting documents or correspondence.",
      "What outcome you are seeking.",
    ],
  },
  {
    title: "4. Complaints Process",
    bullets: [
      "We will acknowledge your complaint within 3 working days.",
      "A Complaints Lead will review records and speak to relevant team members.",
      "We aim to provide a full written response within 20 working days.",
      "If more time is needed, we will explain why and provide an updated timeline.",
    ],
  },
  {
    title: "5. If You Remain Dissatisfied",
    paragraphs: [
      "If you are unhappy after our final response, you may escalate your concern to an appropriate external body. For private dental treatment concerns, this may include the Dental Complaints Service.",
    ],
    bullets: [
      "Quality and safety concerns may be raised with the Care Quality Commission (CQC).",
      "Professional conduct concerns may be raised with the General Dental Council (GDC).",
      "Data protection concerns may be raised with the Information Commissioner's Office (ICO).",
    ],
  },
  {
    title: "6. Learning and Improvement",
    paragraphs: [
      "Complaint outcomes are reviewed as part of clinical governance and service improvement. We use feedback to improve communication, processes, and patient experience.",
    ],
  },
  {
    title: "7. Accessibility and Support",
    paragraphs: [
      "If you need help making a complaint, including support with language or accessibility needs, please let us know and we will make reasonable adjustments.",
    ],
  },
];

export default function Complaints() {
  return (
    <LegalDocumentPage
      title="Complaints Policy"
      lastUpdated={LAST_UPDATED}
      intro="This policy explains how complaints are handled and how concerns can be escalated if needed."
      sections={sections}
      testIdPrefix="complaints"
    />
  );
}
